import { render, staticRenderFns } from "./v-footer-contact-hours.vue?vue&type=template&id=708cafcc&scoped=true&"
import script from "./v-footer-contact-hours.vue?vue&type=script&lang=js&"
export * from "./v-footer-contact-hours.vue?vue&type=script&lang=js&"
import style0 from "./v-footer-contact-hours.vue?vue&type=style&index=0&id=708cafcc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708cafcc",
  null
  
)

export default component.exports